import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        courseVersion: '=',
        learndashCourses: '=',
        scormCourses: '<',
        forms: '=',
        surveyForms: '<',
        feedbackForms: '=',
        canManageCourse: '=',
        course: '=',
        company: '=',
        loaded: '=',
        activeTab: '<',
        settings: '<'
    },
    template: `
        <courses-courses-steps-version-training
            form="vm.form"
            forms="vm.forms"
            survey-forms="vm.surveyForms"
            feedback-forms="vm.feedbackForms"
            learndash-courses="vm.learndashCourses"
            scorm-courses="vm.scormCourses"
            context="vm.context"
            can-manage-course="vm.canManageCourse"
            course-version="vm.courseVersion"
            course="vm.course"
            company="vm.company"
            loaded="vm.loaded"
            active-tab="vm.activeTab",
            settings="vm.settings"
        />
    `
})

export default class {
    constructor (CourseVersionService, CourseVersionResource, FormFactory) {
        this.CourseVersionResource = CourseVersionResource;
        this.CourseVersionService = CourseVersionService;
        this.FormFactory = FormFactory;
    }

    $onInit () {
        this.context = 'edit';
        this.CourseVersionService.nestCompositeModels(this.courseVersion);
        this.form = this.FormFactory.createFromResource(this.courseVersion);

        if (this.form.model.courseVersionLicences) {
            // convert existing licenceId's to strings to display select values
            this.form.model.courseVersionLicences.forEach(licence => {
                licence.licenceId = licence.licenceId.toString();
            });
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/courses/courses/edit/version/edit/training/index.js